import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-14b9a3b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mainfooter"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

const _hoisted_3 = {
  class: "icp"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
}, "蜀ICP备19019929号", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_ctx.routerQuery.check ? (_openBlock(), _createElementBlock("p", _hoisted_4, "软件名称：基于人工智能的在线实时人体骨骼识别与运动纠错系统V1.0")) : _createCommentVNode("", true), _createElementVNode("a", _hoisted_5, "Copyright © 2021-" + _toDisplayString(new Date().getFullYear()) + " 成都沸彻科技有限公司 版权所有", 1), _hoisted_6])]);
}